import { render, staticRenderFns } from "./ClientAssociatedResourceTabs.vue?vue&type=template&id=37e7f21d&scoped=true&"
import script from "./ClientAssociatedResourceTabs.vue?vue&type=script&lang=js&"
export * from "./ClientAssociatedResourceTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e7f21d",
  null
  
)

export default component.exports